import { render, staticRenderFns } from "./children-documents.vue?vue&type=template&id=5ae1ed6f&"
import script from "./children-documents.vue?vue&type=script&lang=js&"
export * from "./children-documents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports